'use strict';
import {ASSET_FORM_REQUIREMENT_COLLECTION} from '../config';


export function AssetFormRequirementDomainProvider() {
  return {
    $get: [
      'AbstractDomainClass',
      '$$AbstractRequirement',
      function (
        AbstractDomainClass,
        $$AbstractRequirement,
      ) {
        //console.log('Calling AssetFormRequirementDomain');
        function AssetFormRequirementDomain(data) {
          AbstractDomainClass.call(this, AssetFormRequirementDomain, data);
          Object.defineProperty(this, '$type', {value: 'form'});
        }

        $$AbstractRequirement.__inheritFrom(AssetFormRequirementDomain, 'AssetFormRequirementDomain', ASSET_FORM_REQUIREMENT_COLLECTION);

        AssetFormRequirementDomain.$constraints.addConstraints({
          assetTask: {type: 'Domain', domainClass: 'AssetTaskDomain'},
          requirement: {type: 'Domain', domainClass: 'FormRequirementDomain', nullable: true},
          form: {type: 'Domain', domainClass: 'FormDomain'},
          formVersion: {type: 'string'},
          formResponse: {type: 'string', domainClass: 'FormResponseDomain', simpleLink: true},
        });

        return AssetFormRequirementDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/requirements/domain/forms/AssetFormRequirementDomain.js